// extracted by mini-css-extract-plugin
export var editButton = "_lb-0";